<template>
  <div
    v-if="show_Forwarder_Link"
    class="spl-function-button"
    @click.exact="open_External_Tracker"
    @click.stop>
    {{ linkData.providerName }}
  </div>
</template>

<script>
import constants from '@/constants'
import Helpers from '@/helpers.vue'

export default {
  name: 'ExternalTracker',
  mixins: [Helpers],
  props: [
    'parcelDetails',
    'short',
    'providerName',
    'trackerLink'
  ],
  data () {
    return {
      parcel: this.parcelDetails ? this.parcelDetails : null,
      constants,
      linkData: { providerName: this.providerName, link: this.trackerLink }
    }
  },
  computed: {
    show_Forwarder_Link () {
      return this.linkData.link !== '' // this.get_Forwarder_Link !== '';
    },
    formattedProviderName () {
      if (this.short) {
        return this.linkData.providerName
      } else {
        return 'Go to ' + this.linkData.providerName + 'tracker'
      }
    }
  },
  watch: {
    parcelDetails: function (newValue) {
      this.updateLinkData()
    },
    providerName: function (newValue) {
      this.linkData.providerName = newValue
    },
    trackerLink: function (newValue) {
      this.linkData.link = newValue
    }
  },
  mounted () {
    this.updateLinkData()
  },
  methods: {
    open_External_Tracker () {
      var windowSettings = 'enubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes'
      window.open(this.linkData.link, 'external_tracker_window', windowSettings)
    },

    updateLinkData () {
      if (this.parcel) {
        this.linkData = this.getExternalLink(this.parcel, constants)
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';
</style>
